import { render, staticRenderFns } from "./TButton.vue?vue&type=template&id=625c619a&scoped=true"
import script from "./TButton.vue?vue&type=script&lang=js"
export * from "./TButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625c619a",
  null
  
)

export default component.exports